export default __webpack_public_path__ + "static/2_35-7f98c6e2cf60cf0bf696d5c9a3699e50.png";